import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { toast } from '@/app/components/ui/use-toast';
import { ONE_MINUTE } from '@/app/constants';
import type { UploadImageType } from '@/app/types';
import { safeStorage } from '@/app/utils/client';

import { BACKFILL_TIME_DELAY } from '../constants';

/**
 * 处理待回填图片
 * @param param0 doBackFill 回填图片的函数
 */
export const useBackfillData = ({
  doBackFill,
}: {
  doBackFill: (reference: {
    timestamp: number;
    imagePrompt: UploadImageType;
    inspirationId?: string;
    inspirationFrom?: string;
  }) => void;
}) => {
  const t = useTranslations();
  // 处理新开页面的图片回填
  useEffect(() => {
    const handlePendingBackfillImage = async () => {
      try {
        const pendingImageData = safeStorage.getItem('pendingBackfillImage');
        if (!pendingImageData) return;

        const { imagePrompt, timestamp, inspirationId, inspirationFrom } = JSON.parse(pendingImageData) as {
          timestamp: number;
          imagePrompt: UploadImageType;
          inspirationId?: string;
          inspirationFrom?: string;
        };
        // 检查时间戳，避免处理过期数据（1分钟内有效）
        if (Date.now() - timestamp > ONE_MINUTE) {
          safeStorage.removeItem('pendingBackfillImage');
          return;
        }

        doBackFill({ timestamp, imagePrompt, inspirationId, inspirationFrom });
        // 清理 localStorage
        safeStorage.removeItem('pendingBackfillImage');

        toast({
          type: 'success',
          message: t('frameShotDialog.backfillSuccess'),
        });
      } catch (error) {
        console.error('处理待回填图片失败:', error);
        safeStorage.removeItem('pendingBackfillImage');
      }
    };

    // 页面加载后延迟执行，确保组件完全初始化
    const timer = setTimeout(handlePendingBackfillImage, BACKFILL_TIME_DELAY);
    return () => clearTimeout(timer);
  }, [doBackFill, t]);
};
